import React, { useEffect } from "react";
import { Menu } from "react-feather";
import "./header.css";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import isGHMC from "../../Common/helper/helpar";
import { useHeaderStore } from "./headerStore";
import { getMasterAPIStore } from "../../../utils/getMasterAPIStore";

const Header = ({ toggleSidebar }) => {
  const { fetchZoneData, fetchCircleData, fetchWardData, fetchShiftData, fetchOwnerTypeData } = getMasterAPIStore();

  const {sidebarMenuOpen} = useHeaderStore();
  const { i18n } = useTranslation();
  const location = useLocation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const roleName = localStorage.getItem("userName")
  const isProd = isGHMC();
  
  useEffect(() => {
    fetchZoneData();
    fetchCircleData();
    fetchWardData();
    fetchShiftData();
    fetchOwnerTypeData();
  }, []);

  useEffect(() => {
    document.title = isProd ? "Solid Waste Management" : "Solid Waste Management";
  }, []);
  return (
    <div className="header d-print-none">
      <div className="header-container">
        <div className="header-left">
          <div className="navigation-toggler">
            <a href="#" onClick={() => sidebarMenuOpen()} data-action="navigation-toggler">
              <Menu onClick={toggleSidebar} /> 
            </a>
          </div>
        </div>

        <div className="header-body">
          <h4 className={`${isProd ? "text-blue" : "text-red"}`}>
            Solid Waste Management
          </h4>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="header-body-right">
              <ul className="navbar-nav">
                {/* <select
                  className="btn btn-primary-light language_select"
                  onChange={(e) => changeLanguage(e.target.value)}
                  value={i18n.language}
                >
                  <option value="en">English</option>
                  <option value="te">తెలుగు</option>
                </select> */}

                <a href="#" className="m-0" title="User menu" >
                  <div> <img src="/assets/images/user.png" alt="" className="img-fluid" /> </div>
                    <span
                      className="d-sm-inline d-none"
                      style={{ color: "black", fontWeight: '600' }}
                    >
                    {roleName}
                    </span>

                  </a>
                
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
